import PromotionSaga from './sagas/PromotionSaga';

export default [PromotionSaga];